import { render, staticRenderFns } from "./SubscribeLabel.vue?vue&type=template&id=3fd90894"
import script from "./SubscribeLabel.vue?vue&type=script&lang=js"
export * from "./SubscribeLabel.vue?vue&type=script&lang=js"
import style0 from "./SubscribeLabel.vue?vue&type=style&index=0&id=3fd90894&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports